import { useEffect } from "react";
import { useAuth, useUser } from "@/lib/auth";
import { clearPosthogUser, setPosthogUser } from "@/lib/posthog";

// Keeps the PostHog identity/org context in sync with Clerk. Mounted once
// inside <ClerkLoaded> next to SentryIdentity; renders nothing. useAuth().orgId
// is the active organization id (null when the user has no org selected);
// email comes from the Clerk user and rides as a person property.
export function PosthogIdentity(): null {
  const { isSignedIn, userId, orgId } = useAuth();
  const { user } = useUser();
  const email = user?.primaryEmailAddress?.emailAddress ?? null;

  useEffect(() => {
    if (isSignedIn && userId) {
      setPosthogUser(userId, orgId ?? null, email);
    } else {
      clearPosthogUser();
    }
  }, [isSignedIn, userId, orgId, email]);

  return null;
}
